/*
 * @Author: yzr
 * @Date: 2020-12-04 14:03:15
 * @LastEditors: yzr
 * @LastEditTime: 2020-12-04 14:22:59
 */
import RuleModal from './rule_modal.vue';

export default RuleModal;
